import ApiService from "./ApiService";


const USERS_BASE_URL = process.env.REACT_APP_BASE_URL_PERMISSIONS;
const BASE_URL = process.env.REACT_APP_BASE_URL;
// const FILES_BASE_URL = process.env.REACT_APP_BASE_URL_FILES;

export const usersApi = new ApiService(USERS_BASE_URL);
export const baseApi = new ApiService(BASE_URL);
// export const filesApi = new ApiService(FILES_BASE_URL);
